import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ConfirmDialog(props) {

  return (
    <React.Fragment>

      <Dialog
        open={props?.open}
        onClose={props?.handleClose}
        className="create-project tags-modal muiForm-Modal confirmModal"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="model-title">
          {props?.dlgTitle}
        </DialogTitle>
        <DialogContent>
          <div className='pb-3 confirmModal-content'>
            {props?.dlgContent}
          </div>
          {/* <DialogContentText style={{ color: "#f54242" }} id="alert-dialog-description">
           
          </DialogContentText> */}
        </DialogContent>
        <DialogActions
          className="copy-project-model-footer"
          style={{ paddingRight: "16px" }}>

          <Button onClick={props.handleClose} >{props?.cnclBtnLbl}</Button>
          <Button onClick={() => { props?.submitFunction(); props?.handleClose() }}  >{props?.okBtnLbl}</Button>

        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}